var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTinder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 251 160.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b2b2b2;}.cls-2{opacity:0.1;}.cls-3{fill:#21bbee;}.cls-34,.cls-4{fill:#fff;}.cls-5{fill:#ffab8a;}.cls-6{fill:#aed7c5;}.cls-7{fill:#99cfb5;}.cls-8{fill:#97d4b8;}.cls-9{fill:#90d2b1;}.cls-10{fill:#82c2a1;}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_30);}.cls-12{fill:#dc8470;}.cls-13{fill:#6d3300;}.cls-14,.cls-15,.cls-16,.cls-22,.cls-23,.cls-24,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-39,.cls-40,.cls-43,.cls-44{stroke-miterlimit:10;}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_30-2);stroke:url(#D\xE9grad\xE9_sans_nom_50);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_30-3);stroke:url(#D\xE9grad\xE9_sans_nom_50-2);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_30-4);stroke:url(#D\xE9grad\xE9_sans_nom_50-3);}.cls-17{fill:#989898;}.cls-18{fill:#e5e5e5;}.cls-19{opacity:0.4;}.cls-20{fill:gray;}.cls-21{fill:#28406b;}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_33);stroke:url(#D\xE9grad\xE9_sans_nom_33-2);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_33-3);stroke:url(#D\xE9grad\xE9_sans_nom_33-4);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_33-5);stroke:url(#D\xE9grad\xE9_sans_nom_33-6);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_30-5);}.cls-26{opacity:0.6;}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_30-6);}.cls-28{fill:url(#D\xE9grad\xE9_sans_nom_33-7);stroke:url(#D\xE9grad\xE9_sans_nom_33-8);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_33-9);stroke:url(#D\xE9grad\xE9_sans_nom_33-10);}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_33-11);stroke:url(#D\xE9grad\xE9_sans_nom_33-12);}.cls-31{fill:url(#D\xE9grad\xE9_sans_nom_33-13);stroke:url(#D\xE9grad\xE9_sans_nom_33-14);}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_33-15);stroke:url(#D\xE9grad\xE9_sans_nom_33-16);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_33-17);stroke:url(#D\xE9grad\xE9_sans_nom_33-18);}.cls-34{stroke:url(#D\xE9grad\xE9_sans_nom_30-7);}.cls-35{fill:url(#D\xE9grad\xE9_sans_nom_30-8);}.cls-36{fill:url(#D\xE9grad\xE9_sans_nom_33-19);}.cls-37{fill:url(#D\xE9grad\xE9_sans_nom_30-9);}.cls-38{fill:#17243f;}.cls-39{fill:url(#D\xE9grad\xE9_sans_nom_33-20);stroke:url(#D\xE9grad\xE9_sans_nom_33-21);}.cls-40{stroke:#fff;fill:url(#D\xE9grad\xE9_sans_nom_30-10);}.cls-41{fill:url(#D\xE9grad\xE9_sans_nom_33-22);}.cls-42{fill:url(#D\xE9grad\xE9_sans_nom_33-23);}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_33-24);stroke:url(#D\xE9grad\xE9_sans_nom_33-25);}.cls-44{fill:url(#D\xE9grad\xE9_sans_nom_33-26);stroke:url(#D\xE9grad\xE9_sans_nom_33-27);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30",
    x1: 167.97,
    y1: 148.14,
    x2: 185.64,
    y2: 148.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16f7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21bbee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-2",
    x1: 86.26,
    y1: 132.29,
    x2: 153.03,
    y2: 132.29,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50",
    x1: 85.76,
    y1: 132.22,
    x2: 153.53,
    y2: 132.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16f7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#19e9c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#1cd5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1fc6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#21beec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21bbee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-3",
    x1: 135.58,
    y1: 135.43,
    x2: 153.03,
    y2: 135.43,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-2",
    x1: 134.49,
    y1: 134.95,
    x2: 153.53,
    y2: 134.95,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-4",
    x1: 83.24,
    y1: 134.58,
    x2: 102.48,
    y2: 134.58,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-3",
    x1: 82.74,
    y1: 134.58,
    x2: 102.98,
    y2: 134.58,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33",
    x1: 114.78,
    y1: 43.45,
    x2: 120.73,
    y2: 43.45,
    gradientTransform: "translate(3.03 106.19) rotate(-45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17243e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-2",
    x1: 114.28,
    y1: 43.45,
    x2: 121.23,
    y2: 43.45,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-3",
    x1: 113.9,
    y1: 44.13,
    x2: 120.36,
    y2: 44.13,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-4",
    x1: 113.4,
    y1: 44.2,
    x2: 120.71,
    y2: 44.2,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-5",
    x1: 115.92,
    y1: 43.45,
    x2: 119.59,
    y2: 43.45,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-6",
    x1: 115.42,
    y1: 43.45,
    x2: 120.09,
    y2: 43.45,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-5",
    x1: 108.58,
    y1: 44.43,
    x2: 125.08,
    y2: 44.43,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-6",
    x1: 118.23,
    y1: 40.58,
    x2: 125.08,
    y2: 40.58,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-7",
    x1: 116.63,
    y1: 31.06,
    x2: 117.02,
    y2: 31.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-8",
    x1: 116.13,
    y1: 31.06,
    x2: 117.52,
    y2: 31.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-9",
    x1: 121.95,
    y1: 32.72,
    x2: 124.31,
    y2: 32.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-10",
    x1: 121.45,
    y1: 32.72,
    x2: 124.81,
    y2: 32.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-11",
    x1: 125.19,
    y1: 37.23,
    x2: 128.98,
    y2: 37.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-12",
    x1: 124.69,
    y1: 37.23,
    x2: 129.48,
    y2: 37.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-13",
    x1: 109.22,
    y1: 32.72,
    x2: 111.57,
    y2: 32.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-14",
    x1: 108.72,
    y1: 32.72,
    x2: 112.07,
    y2: 32.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-15",
    x1: 104.64,
    y1: 37.23,
    x2: 108.43,
    y2: 37.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-16",
    x1: 104.14,
    y1: 37.23,
    x2: 108.93,
    y2: 37.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-17",
    x1: 0.5,
    y1: 73.14,
    x2: 38.16,
    y2: 73.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-18",
    x1: 0,
    y1: 73.14,
    x2: 38.66,
    y2: 73.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-7",
    x1: 4.77,
    y1: 71.46,
    x2: 32.33,
    y2: 71.46,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-8",
    x1: 11.74,
    y1: 71.86,
    x2: 25.46,
    y2: 71.86,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-19",
    x1: 11.78,
    y1: 71.06,
    x2: 25.24,
    y2: 71.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-9",
    x1: 11.65,
    y1: 71.06,
    x2: 25.37,
    y2: 71.06,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-20",
    x1: 201.03,
    y1: 34.65,
    x2: 250.5,
    y2: 34.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-21",
    x1: 200.53,
    y1: 34.65,
    x2: 251,
    y2: 34.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-10",
    x1: 208.41,
    y1: 33.29,
    x2: 243.81,
    y2: 33.29,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-22",
    x1: 216.03,
    y1: 33.02,
    x2: 235.43,
    y2: 33.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-23",
    x1: 215.88,
    y1: 33.05,
    x2: 235.58,
    y2: 33.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-24",
    x1: 57.75,
    y1: 13.43,
    x2: 95.84,
    y2: 13.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-25",
    x1: 57.25,
    y1: 13.43,
    x2: 96.34,
    y2: 13.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-26",
    x1: 66.41,
    y1: 16.65,
    x2: 104.5,
    y2: 16.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-27",
    x1: 65.91,
    y1: 16.65,
    x2: 105,
    y2: 16.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.9,158v1.09a1.63,1.63,0,0,1-1.76,1.45H37a1.63,1.63,0,0,1-1.76-1.45V158A1.63,1.63,0,0,1,37,156.51H218.14A1.63,1.63,0,0,1,219.9,158Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M189.82,139.52a59.83,59.83,0,0,1-13.72,16.2,69,69,0,0,1-6,4.45H77c-1.14-.6-2.28-1.21-3.41-1.83-1.5-.84-3-1.7-4.44-2.62-5.4-3.39-10.35-7.44-13.67-12.72-4.21-6.69-5.21-15.75-.62-22.21,2.17-3.05,5.45-5.44,6.69-8.93,2.12-6-2.65-12.08-4.42-18.21-2.57-8.85,2-19.14,10.35-23.5,5.61-2.92,13-3.75,16.32-9,1.43-2.28,1.8-5,2.83-7.49,2.27-5.45,7.7-9.19,13.44-11.14,13.42-4.54,29-.48,40.1,7.56a7.41,7.41,0,0,0,2.53,1.4,7.34,7.34,0,0,0,2.76-.08c6.37-1,12.94-1.4,19.25-.11s12.38,4.46,16.09,9.56,4.79,12,4.24,18.38A44.27,44.27,0,0,1,182,92a10.4,10.4,0,0,0-.91,3.05c-.35,5,7.22,9.29,9.9,13C197.63,117.07,195.36,129.8,189.82,139.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92,63.9c-.32.2-.64.4-1,.58L90,65c-.67.35-1.34.7-2,1s-1.35.66-2,1l-2,.94c-1.38.62-2.75,1.24-4.09,1.89s-2.68,1.34-4,2.1l-.48.28-.46.3-.24.15-.23.15-.23.15-.11.08-.11.08c-.61.41-1.2.85-1.77,1.31l-.42.35c-.07,0-.13.12-.2.18l-.21.18-.2.18-.2.19-.39.37-.38.39-.18.2-.1.09-.09.11-.35.4-.18.21,0,0,0,.05-.09.11-.33.42-.17.21-.16.22c-.2.3-.42.58-.61.89l-.29.45-.07.11-.07.12-.13.23-.27.47c-.09.15-.17.31-.25.47a20.73,20.73,0,0,0-1.54,4,18.69,18.69,0,0,0-.68,4.2l0,.53c0,.18,0,.35,0,.53l0,.54v.26l0,.27,0,.53.06.54,0,.26,0,.14V93l.07.53c.19,1.43.49,2.84.82,4.26.16.71.34,1.42.5,2.14L66.4,101c.09.36.17.71.25,1.07l.11.54.06.27.06.28.11.54c0,.18.06.36.1.54.14.73.24,1.47.32,2.2s.13,1.48.14,2.23a20.59,20.59,0,0,1-.08,2.22,18.44,18.44,0,0,1-.34,2.21c0,.18-.09.36-.13.54s-.11.36-.16.54l-.08.26-.09.27c-.07.17-.13.35-.2.52l-.11.26-.11.26c-.07.17-.16.33-.24.5l-.13.25-.14.24-.14.24-.15.24a10.26,10.26,0,0,1-1.4,1.74L64,119a10.73,10.73,0,0,0,1.31-1.78c0-.08.1-.16.14-.24l.13-.24.13-.25.12-.24.22-.51.1-.25.09-.26c.07-.17.12-.34.18-.52s0-.17.08-.26l.07-.26c0-.18.1-.36.14-.54s.08-.35.11-.53a15.88,15.88,0,0,0,.27-2.17,22.8,22.8,0,0,0-.16-4.37q-.14-1.08-.36-2.16c0-.18-.07-.36-.11-.54l-.12-.53,0-.27-.07-.27-.12-.53c-.34-1.43-.72-2.84-1.06-4.27s-.67-2.85-.88-4.31a23.75,23.75,0,0,1-.25-4.38,19.35,19.35,0,0,1,.69-4.34,20.94,20.94,0,0,1,4.06-7.81l.08-.11,0-.06,0,0L69,76.7l.37-.42.09-.1.1-.1.2-.2.39-.4.41-.38.2-.19.22-.19.21-.18.21-.18.44-.36.22-.17.22-.17.22-.17.23-.17L73.2,73l.47-.32.11-.08.12-.07.24-.16.24-.15.24-.15.48-.29.48-.28c1.31-.75,2.66-1.42,4-2l2.07-.92,2.08-.88a85.64,85.64,0,0,0,8.18-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.68,76.37c.14.48.27,1,.37,1.46l.09.37.07.38.07.37,0,.18,0,.19.12.75.09.75,0,.19c0,.07,0,.13,0,.19l0,.38,0,.38,0,.38,0,.38v.38l0,.76c0,.51,0,1,0,1.52l0,.38c0,.13,0,.26,0,.38l0,.38c0,.13,0,.26,0,.38l-.08.76c0,.25-.07.51-.1.76l-.12.75-.07.38c0,.13-.05.25-.07.38s-.05.25-.08.37,0,.25-.08.38l-.18.74c-.25,1-.55,2-.78,2.91-.11.47-.22,1-.29,1.42a9.57,9.57,0,0,0-.11,1.41,7.55,7.55,0,0,0,.51,2.73,11.82,11.82,0,0,0,1.34,2.56c.27.4.56.81.86,1.2s.61.79.92,1.19c.63.79,1.28,1.58,1.91,2.4a23.56,23.56,0,0,1,1.73,2.57,22.27,22.27,0,0,1,1.37,2.77,24.82,24.82,0,0,1,1,2.91l.18.74.15.75c0,.12.05.25.07.37l.06.38c0,.25.06.5.09.75l.05.38,0,.38c0,.25,0,.5,0,.75v.38c0,.13,0,.25,0,.38s0,.5,0,.75h-.08a22.93,22.93,0,0,0-.29-3c-.05-.25-.08-.5-.14-.74l-.07-.37c0-.12-.05-.25-.09-.37l-.18-.73-.2-.72a25.87,25.87,0,0,0-1.06-2.82,21.41,21.41,0,0,0-1.41-2.68l-.09-.16-.11-.16-.2-.32-.21-.31-.22-.31c-.29-.42-.6-.82-.91-1.22-.63-.8-1.29-1.57-1.93-2.36s-1.28-1.59-1.85-2.44a13,13,0,0,1-1.42-2.68,8.45,8.45,0,0,1-.41-1.47,8.36,8.36,0,0,1-.13-1.5,12.5,12.5,0,0,1,.45-3c.25-1,.56-1.94.82-2.9s.48-2,.65-2.94a29.91,29.91,0,0,0,.36-3c.05-.5.06-1,.08-1.5V83.1a1.2,1.2,0,0,0,0-.19V82l0-.37v-.38a1.21,1.21,0,0,1,0-.19l0-.18-.05-.75-.08-.75a29.62,29.62,0,0,0-.48-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.73,55.11a5.63,5.63,0,0,0,.84.85,7.08,7.08,0,0,0,1,.63,8.36,8.36,0,0,0,1.12.43,11.48,11.48,0,0,0,1.16.27,17.72,17.72,0,0,0,2.41.24l.61,0h.62l1.23,0h5c.83,0,1.66,0,2.49,0l.62,0,.63,0,1.24.06.63.05.62,0c.42,0,.84.07,1.25.12l.63.07.62.08.31,0,.31,0,.62.11q1.24.23,2.46.54c.41.1.82.21,1.22.34l.3.09.3.1.59.21.59.22.29.12.29.11c.39.16.77.34,1.15.52l.56.28.55.3.27.16.27.16c.18.1.35.21.53.33l.26.17.25.18.51.36.24.19.24.2.13.09.11.1.24.21c.3.27.6.55.89.85s.55.6.81.92l-.06,0a17.42,17.42,0,0,0-1.8-1.63,18.9,18.9,0,0,0-2-1.36A21.32,21.32,0,0,0,169.63,61c-.75-.33-1.52-.62-2.3-.88A31.51,31.51,0,0,0,162.54,59c-1.63-.26-3.27-.42-4.92-.52-3.3-.2-6.6-.18-9.91-.29-.41,0-.83,0-1.24-.06l-.62,0-.62,0a17.14,17.14,0,0,1-2.46-.35c-.4-.1-.8-.21-1.19-.35a7.54,7.54,0,0,1-1.12-.51,6.06,6.06,0,0,1-1-.72,5.05,5.05,0,0,1-.79-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94,109.64l-.26,2.07-.35,2.77a0,0,0,0,1,0,0l-7.13.88-.2,0s0,0,0,0l-.11-.29-.64-1.71a3.62,3.62,0,0,0-.13-.35,24.23,24.23,0,0,1-1.41-7.85v-.62h0a1,1,0,0,1,.89-1.2,2.56,2.56,0,0,1,.78-.08,1.21,1.21,0,0,1,.33.07,1.14,1.14,0,0,1,.19.12s0,0,0,0a.62.62,0,0,1,.25-.28,1.78,1.78,0,0,1,.81-.28c.48-.07,1.25-.13,1.62.25h0a.86.86,0,0,1,.36-.32,2.71,2.71,0,0,1,1-.23,2.07,2.07,0,0,1,.5,0c.14,0,.26.12.4.14s0,0,0,0a3.37,3.37,0,0,0,0-.55l0-1c0-1,.06-2,.1-3l.05-1.57a.9.9,0,0,1,1.79,0h0L94,106.39A14.71,14.71,0,0,1,94,109.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M176.89,117.86a11.53,11.53,0,0,1,1.17,1.59A16,16,0,0,1,179,121a19,19,0,0,1,1.25,3.18,22.8,22.8,0,0,1,0,12.72,19,19,0,0,1-1.25,3.18c-.27.53-.56,1.06-.9,1.59a12.53,12.53,0,0,1-1.18,1.59,11.74,11.74,0,0,1-1.19-1.59q-.49-.79-.9-1.59a20.94,20.94,0,0,1-1.25-3.18,22.16,22.16,0,0,1-.9-6.36,22.53,22.53,0,0,1,.91-6.36,20,20,0,0,1,1.26-3.18,15.86,15.86,0,0,1,.89-1.59A12.53,12.53,0,0,1,176.89,117.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M186.67,120.17a12.33,12.33,0,0,1,.12,1.79c0,.58,0,1.15-.07,1.71a24.62,24.62,0,0,1-.51,3.26,31.6,31.6,0,0,1-5.34,11.62,25.83,25.83,0,0,1-2.18,2.55c-.4.41-.82.81-1.27,1.19a13.06,13.06,0,0,1-1.46,1.12,12.37,12.37,0,0,1-.13-1.79c0-.59,0-1.15.07-1.71a24.77,24.77,0,0,1,.51-3.27,30.18,30.18,0,0,1,2.07-6.07,31.22,31.22,0,0,1,3.29-5.54,25.83,25.83,0,0,1,2.18-2.55q.6-.62,1.26-1.2A15.52,15.52,0,0,1,186.67,120.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M167.57,121.76a14.35,14.35,0,0,1,1.53,1.11c.47.39.9.79,1.32,1.19a23,23,0,0,1,2.22,2.56,27.5,27.5,0,0,1,3.23,5.59,26.57,26.57,0,0,1,1.84,6.14,22.51,22.51,0,0,1,.31,3.32c0,.57,0,1.15-.05,1.75a12.52,12.52,0,0,1-.28,1.83,13.08,13.08,0,0,1-1.53-1.11,16.87,16.87,0,0,1-1.32-1.19,23.94,23.94,0,0,1-2.23-2.55,27.28,27.28,0,0,1-3.21-5.6,26.8,26.8,0,0,1-1.84-6.15,22.38,22.38,0,0,1-.31-3.32c0-.57,0-1.15.05-1.74A12.46,12.46,0,0,1,167.57,121.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M187.75,130.42a8,8,0,0,1,.1,1.35,12.41,12.41,0,0,1-.06,1.24,13.89,13.89,0,0,1-.45,2.31,15.51,15.51,0,0,1-1.82,4.06,15.92,15.92,0,0,1-2.89,3.44,14.35,14.35,0,0,1-1.92,1.44c-.35.22-.72.43-1.12.63a9.63,9.63,0,0,1-1.29.52,7.85,7.85,0,0,1-.1-1.34,10.17,10.17,0,0,1,.06-1.25,13.11,13.11,0,0,1,.44-2.31,15.15,15.15,0,0,1,1.83-4,16,16,0,0,1,2.9-3.44,15.25,15.25,0,0,1,1.92-1.44q.53-.33,1.11-.63A9.62,9.62,0,0,1,187.75,130.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M165.68,129.06a10.23,10.23,0,0,1,1.33.59c.41.22.79.44,1.16.68a15.36,15.36,0,0,1,2,1.56,16.76,16.76,0,0,1,3,3.66,16.47,16.47,0,0,1,1.81,4.29,14.33,14.33,0,0,1,.41,2.43c0,.42,0,.86,0,1.3a9,9,0,0,1-.15,1.41,10.23,10.23,0,0,1-1.33-.58c-.41-.22-.8-.44-1.16-.68a14.09,14.09,0,0,1-2-1.56,16.87,16.87,0,0,1-4.75-8,14.38,14.38,0,0,1-.41-2.42c0-.43,0-.86,0-1.31A7.92,7.92,0,0,1,165.68,129.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M176.48,126.5a9.09,9.09,0,0,1,.92,1.1,10.36,10.36,0,0,1,.72,1.1,14.59,14.59,0,0,1,1,2.24,16.54,16.54,0,0,1,.6,9.17,14.17,14.17,0,0,1-.76,2.34,13,13,0,0,1-.58,1.19,8.72,8.72,0,0,1-.78,1.2,9.93,9.93,0,0,1-.92-1.1,11.6,11.6,0,0,1-.72-1.11,14.23,14.23,0,0,1-1.06-2.24,16.37,16.37,0,0,1-.57-9.16,14.52,14.52,0,0,1,.75-2.35c.17-.39.36-.79.57-1.18A10.19,10.19,0,0,1,176.48,126.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M185.64,140v10.34a6,6,0,0,1-6.1,5.89h-5.47a6.19,6.19,0,0,1-4.19-1.61,5.75,5.75,0,0,1-1.91-4.28V140Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.76,77.48c-3.12,6.08-3.51,13.07-3.41,19.75.05,3.28.32,6.6-.4,9.8-.68,3-2.2,5.73-3.33,8.59s-1.85,6-.89,9c.91,2.77,3.23,4.9,5.7,6.55s5.21,3,7.54,4.79c1.76,1.37,3.27,3,5.06,4.34a17.79,17.79,0,0,0,8.78,3.36,5.19,5.19,0,0,0,2.22-.14c1.81-.63,2.52-2.74,2.62-4.59s-.12-3.81.76-5.46c1.36-2.52,4.66-3.23,7.27-4.54a13.59,13.59,0,0,0,6.74-15.84c-.63-1.94-1.7-3.72-2.4-5.64-2.38-6.59-.85-13.77-1.3-20.58-.65-9.83-7.93-19.41-18.82-19.27a18.52,18.52,0,0,0-10.79,3.48,19.21,19.21,0,0,0-2.22,2,6.88,6.88,0,0,0-.5.55,21,21,0,0,0-1.92,2.64A7.13,7.13,0,0,0,101.76,77.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M116,104.54h0a2.37,2.37,0,0,0,2.74,0h0a2.34,2.34,0,0,1,1.22-.43,8,8,0,0,0,1.39-.21l.23-3.53-8.21.07.3,3.52a9.89,9.89,0,0,0,1.11.15A2.4,2.4,0,0,1,116,104.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.2,105.39l.1-1.49a8,8,0,0,1-1.39.21,2.34,2.34,0,0,0-1.22.43,2.37,2.37,0,0,1-2.74,0,2.4,2.4,0,0,0-1.22-.43,9.89,9.89,0,0,1-1.11-.15l.16,1.83a2.56,2.56,0,0,1-1.5,2.51,59,59,0,0,1-5.59,2.35c-2.74.91,13.76,4.8,20.39,0l.28-.62s-2.34-.91-4.32-1.74A3,3,0,0,1,121.2,105.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.1,91.47a2.46,2.46,0,0,1-1.8,3.18,3,3,0,0,1-3.11-2.45A2.17,2.17,0,0,1,105,89.35,2.68,2.68,0,0,1,108.1,91.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M107.83,92a2.27,2.27,0,0,0-2.6-1.8,1.84,1.84,0,0,0-1.57,2.42,2.55,2.55,0,0,0,2.64,2.09,2.09,2.09,0,0,1-2.17-1.72,1.51,1.51,0,0,1,1.29-2,1.87,1.87,0,0,1,2.14,1.48,1.73,1.73,0,0,1-1.17,2.21A2.1,2.1,0,0,0,107.83,92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.69,91.47a2.46,2.46,0,0,0,1.8,3.18,3,3,0,0,0,3.11-2.45,2.17,2.17,0,0,0-1.85-2.85A2.68,2.68,0,0,0,126.69,91.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M127,92a2.27,2.27,0,0,1,2.6-1.8,1.84,1.84,0,0,1,1.57,2.42,2.55,2.55,0,0,1-2.64,2.09,2.09,2.09,0,0,0,2.17-1.72,1.51,1.51,0,0,0-1.29-2,1.87,1.87,0,0,0-2.14,1.48,1.73,1.73,0,0,0,1.17,2.21A2.1,2.1,0,0,1,127,92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M118.8,101.76h0a2.37,2.37,0,0,1-2.74,0h0a2.4,2.4,0,0,0-1.23-.43c-5.08-.35-9.15-4.91-9.15-10.42V87.15c0-5.74,4.41-10.44,9.79-10.44h3.91c5.38,0,9.79,4.7,9.79,10.44v3.76c0,5.51-4.06,10.07-9.15,10.42A2.34,2.34,0,0,0,118.8,101.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M118.77,103.15h0a2.39,2.39,0,0,1-2.75,0h0a2.34,2.34,0,0,0-1.22-.43c-5.09-.35-9.15-4.91-9.15-10.42V88.54c0-5.74,4.41-10.44,9.79-10.44h3.91c5.38,0,9.79,4.7,9.79,10.44V92.3c0,5.51-4.07,10.07-9.15,10.42A2.34,2.34,0,0,0,118.77,103.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M117.42,89.75a15.43,15.43,0,0,1,1,4.14.23.23,0,0,1-.16.24,16.45,16.45,0,0,1-2,.26s1.64-.71,1.53-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.54,88.55a2.52,2.52,0,0,0,.12.29,1.67,1.67,0,0,0,.24.35,2,2,0,0,0,1.33.76,4.61,4.61,0,0,0,3-.62l.48-.2-1.45-.66-1-.5-1.56,0-1.21.58Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 111.72,
    cy: 88.96,
    rx: 1.12,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.72,
    cy: 88.96,
    rx: 0.58,
    ry: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.51,88.55a3.62,3.62,0,0,1-1-.29,6.36,6.36,0,0,1,.64-.32,6.11,6.11,0,0,1,1.47-.45,3.46,3.46,0,0,1,.91,0,4.76,4.76,0,0,1,3.21,1.69l0,0A9.68,9.68,0,0,0,111.65,88a4.05,4.05,0,0,0-2.11.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.69,88.55a1,1,0,0,1-.12.29,1.36,1.36,0,0,1-.24.35A2,2,0,0,1,124,90a4.61,4.61,0,0,1-3-.62l-.48-.2,1.45-.66,1-.5,1.56,0,1.2.58Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 123.37,
    cy: 88.96,
    rx: 1.12,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.37,
    cy: 88.96,
    rx: 0.58,
    ry: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.73,88.55a3.62,3.62,0,0,0,1-.29,6.36,6.36,0,0,0-.64-.32,6.25,6.25,0,0,0-1.47-.45,3.46,3.46,0,0,0-.91,0,4.65,4.65,0,0,0-1.56.39,4.43,4.43,0,0,0-1.11.75,4.68,4.68,0,0,0-.54.55l0,0A9.81,9.81,0,0,1,123.59,88a4,4,0,0,1,2.1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M113,83.92c-1,.74-2,1.41-3,2.15-1.61,1.2-3.4,1.66-4.63,3.23.08-.1-.08-.45-.12-.64a11.09,11.09,0,0,1-.21-1.71,10.94,10.94,0,0,1,.43-3.41,9.23,9.23,0,0,1,4.05-5.46,9.06,9.06,0,0,1,2.57-1A13.4,13.4,0,0,1,117.2,77c.49.08,1.08.29,1.13.76s-.32.64-.56.9.13.16-.1.49c-.47.66-1.57,1.79-2.1,2.42A15.2,15.2,0,0,1,113,83.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M125.52,76.74a8.06,8.06,0,0,1,4,6.2,15.71,15.71,0,0,1,0,6.37s-.08,0-.1-.07a8.5,8.5,0,0,0-1-.83c-.61-.59-1.16-1.25-1.78-1.87a40.55,40.55,0,0,0-9.09-7,.58.58,0,0,1-.28-.23.61.61,0,0,1,0-.42c.15-.54.19-1.52.58-2s1.68-.63,2.33-.75A8.33,8.33,0,0,1,125.52,76.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M148.83,155.66l-8.93.06-6.41.05,1.17-7.92H100.24l1.2,8.09c-1.78,0-3.52-.61-5.3-.63-3.43,0-.84,1.76-2.29-2.32a12.25,12.25,0,0,1-.31-4.79c.33-5.26-8.73-11-7.08-16.09A70.6,70.6,0,0,1,89.38,124a24.17,24.17,0,0,1,7.25-9.32,28.84,28.84,0,0,1,8-3.88l6.67-2v.48c0,1.83,2.86,3.31,6.38,3.31s6.38-1.48,6.38-3.31a1.77,1.77,0,0,0-.15-.59,34.41,34.41,0,0,1,15.53,6.59,20.08,20.08,0,0,1,4,4.22c2.56,3.74,3.59,8.66,4.92,12.92,1.48,4.76,2.84,9.56,4.2,14.35a12.79,12.79,0,0,1,.34,1.6C153.36,151.47,152.92,155.63,148.83,155.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M148.83,155.6s-9.05,0-13.25.06c2.89-3.39,9.41-3.21,10.28-8.35,1.72-10.11-4.58-26.63-6.42-32.1a20.08,20.08,0,0,1,4,4.22c2.56,3.73,3.59,8.65,4.92,12.91,1.48,4.75,2.84,9.54,4.2,14.33a12.42,12.42,0,0,1,.34,1.6C153.36,151.41,152.92,155.57,148.83,155.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "139.47 141.84 141.95 147.07 135.71 145.12 139.47 141.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,83c-1,.73-2,1.4-3,2.15a23.89,23.89,0,0,0-4.57,4.11,10.39,10.39,0,0,0-.48-1.56,9.42,9.42,0,0,1,.1-1.67,10.93,10.93,0,0,1,.42-3.41,9.28,9.28,0,0,1,4-5.46,9.12,9.12,0,0,1,2.58-1,13.35,13.35,0,0,1,5.08-.07c.49.08,1.09.29,1.13.77s-.31.64-.56.9.14.16-.09.48c-.47.67-1.57,1.8-2.1,2.43A15.26,15.26,0,0,1,113,83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.47,75.85A8.75,8.75,0,0,1,130,82.07a20.52,20.52,0,0,1-.39,7.24s-.19,0-.21-.07a39.75,39.75,0,0,0-11.79-10.6.71.71,0,0,1-.28-.23.64.64,0,0,1,0-.43h0c.14-.53.18-1.52.57-2s1.69-.63,2.34-.74A8.34,8.34,0,0,1,125.47,75.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.67,86.43a27.81,27.81,0,0,1,6.26-.6s-.82-1.24-3.46-1c-.79.08-1.46.09-2,.12A3.14,3.14,0,0,0,120.67,86.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,86.49l.13,0a3.31,3.31,0,0,1,.89-1.51l-.54,0a2.07,2.07,0,0,0-.28.53A3.56,3.56,0,0,0,120.4,86.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.56,85.5a2.25,2.25,0,0,1,.29-.5c-.76.1-1.09.38-.89,1.44a.12.12,0,0,0,.15.11l.22,0A3.46,3.46,0,0,1,120.56,85.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.12,86.43a27.81,27.81,0,0,0-6.26-.6s.82-1.24,3.45-1c.8.08,1.47.09,2,.12A3.15,3.15,0,0,1,114.12,86.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.39,86.49l-.14,0a3.2,3.2,0,0,0-.88-1.51l.54,0a2.07,2.07,0,0,1,.28.53A3.56,3.56,0,0,1,114.39,86.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.23,85.5a2.25,2.25,0,0,0-.29-.5c.76.1,1.09.38.89,1.44a.12.12,0,0,1-.15.11l-.22,0A3.46,3.46,0,0,0,114.23,85.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M96.25,155.71h0A7.26,7.26,0,0,1,88,149.78l-4.68-30.54a4.43,4.43,0,0,1,3.86-5l5.62-.81a4.3,4.3,0,0,1,4.9,3.51l4.73,30.79A7.09,7.09,0,0,1,96.25,155.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.08,100.73h-.85a4,4,0,0,1-3.87-2.83h0a.42.42,0,0,1,.41-.52h7.77a.41.41,0,0,1,.4.52h0A4,4,0,0,1,118.08,100.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M140.9,129l-1.44,27.16H95.39L94,129a2.2,2.2,0,0,1,.28-1.08,2.38,2.38,0,0,1,2.1-1.22h42.19A2.34,2.34,0,0,1,140.9,129Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 117.87,
    cy: 142.28,
    rx: 2.81,
    ry: 2.71
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M139.46,155.89v.25H95.39L94,129a2.2,2.2,0,0,1,.28-1.08C96.29,133,106.73,150.64,139.46,155.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M86.21,105.1l.06.24.06.24.11.47c.07.32.14.64.2,1s.1.64.14,1c0,.16,0,.33,0,.49a4,4,0,0,1,0,.49,4.17,4.17,0,0,1,0,.5,2.11,2.11,0,0,1,0,.25s0,.09,0,.13l0,.13a1.83,1.83,0,0,1-.11.26.55.55,0,0,1-.2.23.81.81,0,0,1-.58.15.7.7,0,0,1-.5-.3,1.94,1.94,0,0,1-.27-.43,4.43,4.43,0,0,1-.2-.45l-.09-.23a2.17,2.17,0,0,0-.07-.24h0a5.86,5.86,0,0,0,.43.87,2.21,2.21,0,0,0,.28.4.69.69,0,0,0,.18.16.62.62,0,0,0,.23.07.57.57,0,0,0,.62-.31.83.83,0,0,0,.08-.22,2,2,0,0,0,.06-.48,3.84,3.84,0,0,0,0-.48,17.76,17.76,0,0,0-.19-1.93c-.08-.65-.19-1.28-.29-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M88.73,104.74l.08.25.07.24c0,.17.09.33.13.5l.12.5c0,.16.07.33.1.5a8.77,8.77,0,0,1,.12,1,7.08,7.08,0,0,1,0,1v.26a2,2,0,0,1,0,.26,2.34,2.34,0,0,1,0,.26,1.38,1.38,0,0,1-.08.27.94.94,0,0,1-.14.26.64.64,0,0,1-.25.21.66.66,0,0,1-.31.09,1,1,0,0,1-.3,0,1.15,1.15,0,0,1-.28-.09,1.43,1.43,0,0,1-.24-.16,2.73,2.73,0,0,1-.38-.38c-.11-.13-.22-.27-.32-.41a1.37,1.37,0,0,1-.15-.21l-.14-.22h0a7,7,0,0,0,.66.78,2.57,2.57,0,0,0,.39.35,1.17,1.17,0,0,0,.47.21.72.72,0,0,0,.5-.07.65.65,0,0,0,.3-.39,2.17,2.17,0,0,0,.07-.24,2.17,2.17,0,0,1,0-.25l0-.25v-.26a10.62,10.62,0,0,0-.08-2c-.09-.67-.23-1.34-.37-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.48,106.91a6.54,6.54,0,0,0-.28-1.16c-.13-.45-.21-.91-.32-1.37,0-.13-.1-.62-.28-.4a4,4,0,0,0-.46,1.38h0a7.49,7.49,0,0,0-1.77-.1c0,.44.1,1,.15,1.39s0,.83.09,1.27a.41.41,0,0,0,0,.19.65.65,0,0,0,.16.17,8.19,8.19,0,0,0,1,.64,2.83,2.83,0,0,0,.36.16l.22,1.11.43.19c.12-.45.15-.91.27-1.36s.26-.92.35-1.39A2.48,2.48,0,0,0,94.48,106.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M91.25,104.41l.06.25,0,.24.1.5.08.5c0,.16,0,.33.08.49,0,.33.1.67.13,1a7.08,7.08,0,0,1,0,1,3,3,0,0,1-.07.51l0,.13,0,.13a1.45,1.45,0,0,1-.11.26,1.11,1.11,0,0,1-.16.24,1.14,1.14,0,0,1-.23.2.73.73,0,0,1-.32.09.64.64,0,0,1-.31-.06,1.19,1.19,0,0,1-.44-.36l-.31-.42-.26-.43-.13-.23c0-.07-.07-.15-.11-.23h0a6.89,6.89,0,0,0,.57.84c.1.14.21.27.32.4a1,1,0,0,0,.18.17,1,1,0,0,0,.21.14.56.56,0,0,0,.49,0,1.14,1.14,0,0,0,.41-.61l0-.12a.5.5,0,0,0,0-.12,2.87,2.87,0,0,0,.07-.5,10.28,10.28,0,0,0-.09-2l-.23-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M94,105.78a4.44,4.44,0,0,0-.61-.22,4.56,4.56,0,0,0-.64-.14l-.32,0H92.1l-.31,0a1,1,0,0,0-.3.08h0a.1.1,0,0,1-.12-.06.09.09,0,0,1,.06-.12h0l.33-.07h.34a1.84,1.84,0,0,1,.33,0,1.91,1.91,0,0,1,.33.06,4.19,4.19,0,0,1,.63.19A4,4,0,0,1,94,105.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M93.6,109c-.31-.13-.63-.26-1-.37a4,4,0,0,0-.49-.15l-.24,0-.12,0h-.13a.1.1,0,0,1-.1-.09.11.11,0,0,1,.1-.1h0a1.16,1.16,0,0,1,.28.05l.26.07.48.2C93,108.68,93.3,108.83,93.6,109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M119.74,57.34c0,.82-1.22,1.49-2.72,1.49s-2.72-.67-2.72-1.49V54.91h5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M117,58.83a4.28,4.28,0,0,1-1.76-.35v.05c0,.54.79,1,1.76,1s1.75-.43,1.75-1v-.05A4.2,4.2,0,0,1,117,58.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M117,55.68c-2,0-3.68-.91-3.68-2s1.65-2,3.68-2,3.68.91,3.68,2S119.05,55.68,117,55.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M117,55.68c-2,0-3.55-.84-3.67-1.9V54.9c0,1.12,1.65,2,3.68,2s3.68-.91,3.68-2V53.65C120.7,54.77,119.05,55.68,117,55.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M117,54.91c-1.26,0-2.28-.56-2.28-1.26s1-1.25,2.28-1.25,2.28.56,2.28,1.25S118.28,54.91,117,54.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M125.08,42.29a7.93,7.93,0,0,1-1.43,4.55,8.94,8.94,0,0,1-.71.89,8,8,0,0,0-1.39,2.08,8.06,8.06,0,0,0-.68,2.39A2.86,2.86,0,0,1,118,54.67h-2.33a3,3,0,0,1-1.92-.71,2.74,2.74,0,0,1-1-1.76,8,8,0,0,0-2.06-4.47,8,8,0,0,1-2.14-5.44,8.28,8.28,0,0,1,14.58-5.18A7.93,7.93,0,0,1,125.08,42.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M123.65,46.84a13,13,0,0,0-5.42-12.53,8.25,8.25,0,0,1,4.93,2.8,8,8,0,0,1,.49,9.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.75,49a30.7,30.7,0,0,0-.53-4.28c-.13-.71-.29-1.41-.46-2.11s-.35-1.35-.57-2a1.8,1.8,0,0,0-1.48-1.16.64.64,0,0,0-.5.14.49.49,0,0,0-.17.44,1.6,1.6,0,0,0,.16.48c.06.13.13.26.2.38a3.45,3.45,0,0,0,2.95,1.71A2.81,2.81,0,0,0,118,40.69a1.43,1.43,0,0,0,.07-.46.59.59,0,0,0-.27-.48.8.8,0,0,0-.93,0,1.11,1.11,0,0,0-.36.91,1.9,1.9,0,0,0,.25.86,2.43,2.43,0,0,0,1.41,1.08,2.86,2.86,0,0,0,1.93-.2,3.2,3.2,0,0,0,.82-.53,2.18,2.18,0,0,0,.6-.72.9.9,0,0,0,0-1A.71.71,0,0,0,121,40a1,1,0,0,0-.52,0,.92.92,0,0,0-.43.29,1.51,1.51,0,0,0-.29.49,7.61,7.61,0,0,0-.29,1c-.19.71-.35,1.42-.5,2.14a36.66,36.66,0,0,0-.6,4.42l-.06,1.06a.29.29,0,0,0,.58,0q0-1,.15-2.07,0-.51.12-1l0-.25c0,.07,0,0,0,0v-.07l0-.13c0-.17.06-.34.08-.51a35.13,35.13,0,0,1,.9-4l.06-.2a.59.59,0,0,0,0-.08l0-.06v0l.1-.18,0,0s0,0,0,0,.07-.09.08-.1l0,0s-.07,0,0,0l.09-.05s.06,0,0,0,0,0,0,0a.53.53,0,0,1,.12,0s-.06,0,0,0h.09s0,0,0,0l.08,0h0s0,0,0,0a.07.07,0,0,0,0,0h0l0,0h0s0,0,0,0,0,0,0,0l0,0s0-.07,0,0,0,0,0,0v0s0,0,0,0,0,0,0,.07v0c0,.06,0-.07,0,0l0,.08,0,.05s0,0,0,.06v0l0,0a.41.41,0,0,1,0,.09l0,.07,0,0,0,0s0,0,0,0a2.13,2.13,0,0,1-.3.3l-.16.14,0,0c-.06,0,0,0,0,0l-.1.07a2.71,2.71,0,0,1-.37.21l-.1,0-.05,0h0l-.2.07-.43.1c.09,0,0,0,0,0h-.54s.07,0,0,0l-.2,0-.18-.06,0,0s-.07,0,0,0l-.09-.05a2.27,2.27,0,0,1-.34-.19s0,0,0,0l0,0-.07,0-.14-.14-.07-.08,0,0h0a.91.91,0,0,1-.11-.16l-.09-.15,0,0c0,.07,0,0,0,0l0-.09,0-.17s0-.14,0,0a.31.31,0,0,1,0-.1.54.54,0,0,1,0-.18v0l0-.1a.43.43,0,0,0,0-.05s0-.06,0,0,0,0,0,0l0-.05,0,0s-.05.05,0,0,.07,0,.08-.06,0,0,0,0h0s-.07,0,0,0h.08c-.07,0-.06,0,0,0h.14c-.07,0,0,0,0,0l0,0s0,0,0,0l0,0c0,.05,0,0,0,0s0,0,0,0,0-.06,0,0h0s0,0,0,0,0,0,0,.06a.31.31,0,0,1,0,.1c0,.06,0-.07,0,0s0,0,0,.06a1.4,1.4,0,0,1-.1.35l0,0s0-.06,0,0a.2.2,0,0,1,0,.08l-.09.17-.1.14,0,0s0-.06,0,0l-.08.08a1.66,1.66,0,0,1-.27.26l-.06.05h0l0,0a.91.91,0,0,1-.16.11,2.16,2.16,0,0,1-.34.17h0l0,0-.1,0-.19.05-.18,0-.08,0h0a1.61,1.61,0,0,1-.38,0h-.09s-.14,0,0,0l-.2,0a2.72,2.72,0,0,1-.38-.11l-.09,0s.07,0,0,0h0l-.18-.09-.34-.2-.08-.06h0l0,0-.16-.13a2.47,2.47,0,0,1-.28-.28l-.13-.14c.06.07,0,0,0,0l-.06-.08-.21-.34-.08-.16a.42.42,0,0,1,0-.1c0,.07,0,0,0,0l0-.06a1.15,1.15,0,0,1-.06-.17s0-.06,0,0,0,0,0,0,0-.05,0,0,0,0,0,0,0,.06,0,0,0,.05,0,0-.06,0,0,0-.07,0,0,0h.11l.09,0,.1,0h0s.08.05,0,0l.18.08.09.06,0,0,0,0h0s.07.05.09.07l.06.06.08.07,0,0,0,0h0l.1.15,0,.05s0,.06,0,0l0,.09c0,.16.09.32.14.47l.27,1c.17.65.33,1.3.46,2s.27,1.33.37,2l0,.24,0,.11c0,.07,0-.06,0,0v.08l.06.5c0,.32.08.65.1,1s.05.64.07,1a.3.3,0,0,0,.29.28.3.3,0,0,0,.29-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M116.83,33.15a.2.2,0,0,1-.2-.19V29.17a.2.2,0,0,1,.2-.19.2.2,0,0,1,.19.19V33A.2.2,0,0,1,116.83,33.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M122.15,34.54a.16.16,0,0,1-.1,0,.18.18,0,0,1-.07-.25L124,31a.19.19,0,1,1,.33.19l-2,3.28A.18.18,0,0,1,122.15,34.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M125.38,38.36a.18.18,0,0,1-.16-.09.17.17,0,0,1,.07-.25l3.4-1.9a.21.21,0,0,1,.27.07.18.18,0,0,1-.08.25l-3.4,1.9A.16.16,0,0,1,125.38,38.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M111.38,34.54a.19.19,0,0,1-.17-.09l-2-3.28a.19.19,0,0,1,.07-.26.21.21,0,0,1,.27.07l2,3.29a.18.18,0,0,1-.07.25A.15.15,0,0,1,111.38,34.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M108.24,38.36a.16.16,0,0,1-.1,0l-3.41-1.9a.18.18,0,0,1-.07-.25.21.21,0,0,1,.27-.07l3.4,1.9a.17.17,0,0,1,.07.25A.18.18,0,0,1,108.24,38.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M19.27,54c10.42,0,18.85,8.09,18.89,18.19a17.83,17.83,0,0,1-4.24,11.6h0l2.4,7.63a.73.73,0,0,1-1,.85l-7.72-3.61h-.5a17.16,17.16,0,0,1-7.84,1.85A18.52,18.52,0,0,1,.5,72.15C.53,62.12,8.92,54,19.27,54Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 18.55,
    cy: 71.46,
    rx: 13.28,
    ry: 12.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M25.19,74.74l-3-2.88,3-2.88a.86.86,0,0,0,0-1.25L22.88,65.5a1,1,0,0,0-1.3,0l-3,2.88-3-2.88a.94.94,0,0,0-1.29,0L12,67.73A.86.86,0,0,0,12,69l3,2.88-3,2.88A.86.86,0,0,0,12,76l2.31,2.23a.94.94,0,0,0,1.29,0l3-2.88,3,2.88a1,1,0,0,0,1.3,0L25.19,76A.86.86,0,0,0,25.19,74.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M12,75.09A.73.73,0,0,1,12,74l3.07-3-3.07-3A.73.73,0,0,1,12,67l2.31-2.23a.8.8,0,0,1,1.11,0l3.08,3,3.07-3a.8.8,0,0,1,1.11,0L25,67a.75.75,0,0,1,0,1.07l-3.08,3L25,74a.75.75,0,0,1,0,1.07l-2.32,2.24a.81.81,0,0,1-1.11,0l-3.07-3-3.08,3a.81.81,0,0,1-1.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M24.91,67.11a.61.61,0,0,1,0,.89l-3.17,3.06,3.17,3a.62.62,0,0,1,0,.9L22.6,77.24a.69.69,0,0,1-.93,0l-3.16-3.06-3.17,3.06a.69.69,0,0,1-.93,0L12.1,75a.61.61,0,0,1,0-.89l3.17-3L12.1,68a.61.61,0,0,1,0-.89l2.31-2.23a.67.67,0,0,1,.93,0l3.17,3.05,3.16-3.05a.67.67,0,0,1,.93,0l2.31,2.23m.19-.18L22.79,64.7a.94.94,0,0,0-1.3,0l-3,2.88-3-2.88a.92.92,0,0,0-1.29,0l-2.32,2.23a.88.88,0,0,0,0,1.25l3,2.88-3,2.87a.88.88,0,0,0,0,1.25l2.32,2.23a.92.92,0,0,0,1.29,0l3-2.87,3,2.87a.92.92,0,0,0,1.29,0l2.32-2.23a.88.88,0,0,0,0-1.25l-3-2.87,3-2.88a.86.86,0,0,0,0-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M15.14,65.4a5.18,5.18,0,0,1,.74.74c.28.3.58.59.84.9s.59.69.91,1,.56.62.92.67c.61.09,1-.62,1.4-1a9.84,9.84,0,0,1,1.91-1.68,1.85,1.85,0,0,1,1.34-.25l-.58-.55a.66.66,0,0,0-.92,0l-3.17,3-3.17-3a.65.65,0,0,0-.78-.1A1,1,0,0,1,15.14,65.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M24.91,74.11l-.55-.53a1.52,1.52,0,0,1-.18,1,3.91,3.91,0,0,1-.64.77,6.25,6.25,0,0,1-.69.67,1.23,1.23,0,0,1-1.51.2,9.79,9.79,0,0,1-1.83-1.75,11,11,0,0,0-.84-.83,1.71,1.71,0,0,0-.72-.46c-.73-.15-1.34.69-1.81,1.09a3.79,3.79,0,0,1-1.91,1.06,2.14,2.14,0,0,1-2.07-1.33l-.06.06a.61.61,0,0,0,0,.89l2.31,2.24a.69.69,0,0,0,.93,0l3.17-3.06,3.16,3.06a.69.69,0,0,0,.93,0L24.91,75A.62.62,0,0,0,24.91,74.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M225.85,9.46c-13.69,0-24.77,10.62-24.82,23.89a23.42,23.42,0,0,0,5.57,15.24h0l-3.14,10a1,1,0,0,0,1.34,1.11L215,55h.66a22.52,22.52,0,0,0,10.3,2.42c13.67-.07,24.63-10.8,24.59-24S239.44,9.5,225.85,9.46Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 226.11,
    cy: 33.29,
    rx: 17.7,
    ry: 17.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.71,25a4,4,0,0,0-.69,0,5.14,5.14,0,0,0-2.88,1.18A5,5,0,0,0,227,27.77a5.75,5.75,0,0,0-1.24-1.53,5.14,5.14,0,0,0-2.88-1.18l-.26,0h-.22c-3.06-.13-5.23,2.73-5.31,5.41a10.12,10.12,0,0,0,.42,3.23,11.19,11.19,0,0,0,4.39,5.29,24,24,0,0,0,2.23,1.43,21.85,21.85,0,0,1,2.61,1.73.32.32,0,0,0,.4,0,20.89,20.89,0,0,1,2.6-1.72A26.6,26.6,0,0,0,232,38.94a11.19,11.19,0,0,0,4.39-5.29,10.12,10.12,0,0,0,.42-3.23C236.73,27.8,234.67,25,231.71,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M225.63,41.4A21,21,0,0,0,223,39.66a24.56,24.56,0,0,1-2.22-1.42A11.12,11.12,0,0,1,216.44,33a9.88,9.88,0,0,1-.41-3.19c.08-2.54,2.08-5.26,4.95-5.26a3.67,3.67,0,0,1,.66.05,5,5,0,0,1,2.8,1.14,4.82,4.82,0,0,1,1.35,1.82A4.83,4.83,0,0,1,227,25.76a5,5,0,0,1,2.8-1.14,3.85,3.85,0,0,1,.67-.05c2.87,0,4.87,2.72,4.94,5.26A10.17,10.17,0,0,1,235,33a11.18,11.18,0,0,1-4.34,5.22c-.71.52-1.48,1-2.23,1.43a22,22,0,0,0-2.62,1.73l-.1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M230.48,24.71c2.74,0,4.72,2.57,4.79,5.13a9.82,9.82,0,0,1-.4,3.14,10.91,10.91,0,0,1-4.28,5.14c-1.55,1.15-3.37,2-4.86,3.17-1.49-1.22-3.31-2-4.86-3.17A11,11,0,0,1,216.58,33a9.81,9.81,0,0,1-.39-3.14c.07-2.56,2.05-5.13,4.79-5.13a4.72,4.72,0,0,1,.64.05,4.91,4.91,0,0,1,2.72,1.11,3.5,3.5,0,0,1,1.4,2.41,4.61,4.61,0,0,1,1.38-2.41,4.91,4.91,0,0,1,2.72-1.11,4.6,4.6,0,0,1,.64-.05m-9.5-.29c-3,0-5,2.8-5.1,5.41a10.23,10.23,0,0,0,.41,3.24,11.33,11.33,0,0,0,4.39,5.28c.72.53,1.49,1,2.24,1.44a20.63,20.63,0,0,1,2.61,1.72l.2.16.19-.16a23.06,23.06,0,0,1,2.61-1.72,26.6,26.6,0,0,0,2.24-1.44,11.27,11.27,0,0,0,4.39-5.28,10,10,0,0,0,.41-3.24c-.07-2.61-2.13-5.41-5.09-5.41a5.34,5.34,0,0,0-.69,0,5.11,5.11,0,0,0-2.88,1.19,4.91,4.91,0,0,0-1.12,1.53,6,6,0,0,0-1.24-1.53,5.14,5.14,0,0,0-2.88-1.19,5.47,5.47,0,0,0-.69,0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M221.08,25.94l-.15,0a3,3,0,0,0-2.3.46,4.34,4.34,0,0,0-1.56,2.82,7,7,0,0,0,.17,3.28,11,11,0,0,0,.85,2c-.09-.47-.1-1-.14-1.38a6,6,0,0,1,.51-3.31A3.38,3.38,0,0,1,220.19,28c.42-.18,1.12-.26,1.43-.6C222.1,26.82,221.63,26.17,221.08,25.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M235.27,29.84c-.08-2.75-2.36-5.52-5.43-5.08a4.91,4.91,0,0,0-2.72,1.11,4.61,4.61,0,0,0-1.38,2.41,3.5,3.5,0,0,0-1.4-2.41,4.91,4.91,0,0,0-2.72-1.11,3.62,3.62,0,0,0-.73,0,9.09,9.09,0,0,1,2.54,1.93,6.65,6.65,0,0,1,1,1.49,11.61,11.61,0,0,0,.87,1.68A22,22,0,0,0,228,28a5,5,0,0,1,2.95-.79,2.42,2.42,0,0,1,2.11,1.37,5.4,5.4,0,0,1,.46,2.83c-.42,3.59-3.55,6.86-6.95,8.18a3.32,3.32,0,0,1-1.59.27,4.16,4.16,0,0,1-1.36-.56c-1-.51-2.08-.89-3.07-1.42l.3.22c1.55,1.15,3.37,2,4.86,3.17,1.49-1.21,3.31-2,4.86-3.17A10.91,10.91,0,0,0,234.87,33,9.82,9.82,0,0,0,235.27,29.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M91,.5H62.6a4.76,4.76,0,0,0-4.85,4.67v10A4.77,4.77,0,0,0,62.6,19.8h.24L65.23,26a.64.64,0,0,0,1.18,0l4.78-6.16H91a4.77,4.77,0,0,0,4.85-4.68V5.17A4.76,4.76,0,0,0,91,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M99.65,3.72H71.26A4.77,4.77,0,0,0,66.41,8.4v9.94A4.76,4.76,0,0,0,71.26,23h.24l2.39,6.16a.64.64,0,0,0,1.18,0L79.85,23h19.8a4.76,4.76,0,0,0,4.85-4.68V8.4A4.77,4.77,0,0,0,99.65,3.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 76.72,
    cy: 12.75,
    rx: 2.31,
    ry: 2.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 86.04,
    cy: 12.75,
    rx: 2.31,
    ry: 2.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 95.35,
    cy: 12.75,
    rx: 2.31,
    ry: 2.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.38,14.25h0a.05.05,0,0,1,0-.05V8.39a4.51,4.51,0,0,1,2.13-4,5.07,5.07,0,0,1,2.05-.68L77,3.61h0a.05.05,0,1,1,0,.1l-6.52.09a4.93,4.93,0,0,0-2,.67A4.42,4.42,0,0,0,66.44,8.4v5.8A.06.06,0,0,1,66.38,14.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.75,23.09a0,0,0,0,1,0-.05.06.06,0,0,1,0-.06l6.52-.09a5,5,0,0,0,2-.67,4.39,4.39,0,0,0,2.07-3.92V12.5a0,0,0,0,1,.05-.05h0a.06.06,0,0,1,.06.05v5.8a4.53,4.53,0,0,1-2.13,4,5.07,5.07,0,0,1-2,.68l-6.52.09Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinder);
export default __webpack_public_path__ + "static/media/Tinder.51236b3467d75aefe090f14771a507dc.svg";
export { ForwardRef as ReactComponent };